import React, { useContext, useMemo } from 'react';

// OL
import OlCollection from 'ol/Collection';
import OlBaseLayer from 'ol/layer/Base';

// Custom
import { checkIfLayerVisible, getCallDirectLayers, getCallGroupedLayers, getCallGroupedLayersBySwipe } from '@/lib/olHelpers';
import MapContext, { MapContextType } from '@/context/MapContext/MapContext';
import GeoLayer from './GeoLayer';
import GeoLayerCombined from './GeoLayerCombined';
import { ILayerSwiperState } from '@/@types/components/Map/Controls/Custom/LayerTree';


type GeoAPILayersProps = {
  layersCollection: OlCollection<OlBaseLayer>;
  hiddenIDs?: string[];

  swipeValue?: number | null
  swipeState?: ILayerSwiperState
};

const GeoAPILayers = (props: GeoAPILayersProps) => {

  const { layersCollection, hiddenIDs, swipeValue, swipeState } = props;

  const mapContext = useContext<MapContextType | null>(MapContext);
  const { layerVisibility } = mapContext ?? {};

  const layerArray = useMemo(() => layersCollection.getArray(), [layersCollection])

  const directLayers = useMemo(() => getCallDirectLayers(layerArray), [layerArray]);

  const groupLayers = useMemo(() => {
    if (swipeValue !== null && swipeState) {
      // If swiper is active → group layers by L, R, both
      return getCallGroupedLayersBySwipe(layerArray, swipeState);
    }

    // Normal grouping without swipe
    return getCallGroupedLayers(layerArray).map((g) => ({
      ...g,
      swipe: 'both' as const,
    }));
    
  }, [layerArray, swipeState, swipeValue]);

  return layersCollection ? (
    <>
      {/* getOnlyGroupLayers(layersCollection.getArray()).filter(x => x.get("type") !== "special").map(
        (layer: OlLayerGroup, i: number) => (
          // <GroupLayer
          //   key={`${layer.get('id')}-${i}`}
          //   id={layer.get('id')}
          //   title={t(layer.get('title'))}
          // >
            <>
              {getCallDirectLayers(layer.getLayers().getArray()).filter(x => x.get("type") !== "special").map(

                (cl: OlBaseLayer, j: number) => {;
                  const visibility = hiddenIDs ? !hiddenIDs.includes(cl.get('id')) : undefined;
                  return <GeoLayer key={j} id={cl.get('id')} layer={cl} visible={visibility}/>
                }
              )}
              {getCallGroupedLayers(layer.getLayers().getArray()).map(
                (cgl, k: number) => {
                  const visibility = hiddenIDs ? !hiddenIDs.includes(cgl.call_group) : undefined;
                  return <GeoLayerCombined
                    key={k}
                    id={cgl.call_group}
                    layersCollection={new OlCollection(cgl.layers)}
                    visible={visibility}
                  />
                }
              )}
            </>
          // </GroupLayer>
        )
      ) */}
      {directLayers
        .filter((x) => x.get('type') !== 'special')
        .flatMap((l: OlBaseLayer) => {
          // visibility se prvo provjerava preko hiddenId, ako nije tu, onda se racuna dalje u geolayeru
          const visibility = hiddenIDs ? !hiddenIDs.includes(l.get('id')) : undefined;
          const layerId = l.get('id');
          const originalSide = swipeState ? swipeState[layerId] : undefined;

          const elements = [
            <GeoLayer key={`${layerId}-direct-layer`} id={layerId} layer={l} visible={visibility} swipeValue={swipeValue} swipeState={originalSide} />,
          ];

          // "Compare" companion: same backend layer, a second point in time. hacky jbg
          // swipeValue also has to be set - swipeState hangs onto its last L/R assignment even
          // after swipe mode is turned off, only the explicit "Restore" clears it.
          const timeseries = l.get('timeseries');
          const swipeModeOn = swipeValue !== undefined && swipeValue !== null;
          if (timeseries && swipeModeOn && (originalSide === 'L' || originalSide === 'R')) {
            const companionId = `${layerId}::cmp`;
            const companionChecked = layerVisibility ? layerVisibility[companionId] !== false : true;
            const baseVisible = visibility !== undefined ? visibility : mapContext ? checkIfLayerVisible(mapContext, l) : true;
            const companionSide = originalSide === 'L' ? 'R' : 'L';
            const companionVisible = companionChecked && baseVisible;

            elements.push(
              <GeoLayer
                key={`${companionId}-direct-layer`}
                id={companionId}
                layer={l}
                visible={companionVisible}
                swipeValue={swipeValue}
                swipeState={companionSide}
              />
            );
          }

          return elements;
        })}

      {groupLayers.map((gl) => {
        const visibility = hiddenIDs ? !hiddenIDs.includes(gl.call_group) : undefined;
        return (
          <GeoLayerCombined
            key={`${gl.call_group}-${gl.swipe}`}
            groupId={`${gl.call_group}-${gl.swipe}`}
            layersCollection={new OlCollection(gl.layers)}
            visible={visibility}
            swipeValue={swipeValue}
            swipeState={swipeState}
          />
        );
      })}

    </>
  ) : null;
};

export default GeoAPILayers;
